import { GetProductAndLanguage } from "@genericComponents/Common.js";
import { InitializeCustomWorker } from "@genericComponents/InitializeCustomWorker.js";
import {
  GetState,
  RemoveState,
  SetState,
} from "@genericComponents/StoreToolkit.js";
import { User } from "@genericComponents/User.js";
import { UnregisterServiceWorkers } from "@src/serviceWorkerRegistration.js";
const ConfigData = await import("@data/ConfigData.js").then(
  (mod) => mod.ConfigData,
);
const GUID = await import("@asyncImports/GUID.js").then((mod) => mod.GUID);
export const SetSessionKey = (sessId, val) => {
  window.sessionStorage.setItem(Encrypt(sessId), val);
};
export const SetSession = (sessId, val) => {
  if (typeof window !== "undefined") {
    window.sessionStorage.setItem(
      Encrypt(sessId),
      Encrypt((val ?? "").toString()),
    );
  }
};
export const SetStorage = (sessId, val) => {
  if (typeof window !== "undefined") {
    window.localStorage.setItem(
      Encrypt(sessId),
      Encrypt((val ?? "").toString()),
    );
  }
};
export const Encrypt = (input) => {
  if (!input && input !== 0) {
    return "";
  }
  let rslts = [];
  for (const s of input.split("")) {
    let y = s.charCodeAt(0);
    y = String.fromCharCode(y + 5);
    rslts.push(y);
  }
  return rslts.join("");
};
export const Decrypt = (input) => {
  if (!input) {
    return "";
  }
  let rslts = [];
  for (const s of input.split("")) {
    let y = s.charCodeAt(0);
    y = String.fromCharCode(y - 5);
    rslts.push(y);
  }
  return rslts.join("");
};
export const GetSessionKey = (sessId, defaultVal = null) => {
  let val = window.sessionStorage.getItem(Encrypt(sessId));
  return !val ? defaultVal : val;
};
export const GetSession = (sessId, defaultVal = null) => {
  let val =
    typeof window === "undefined"
      ? defaultVal
      : window.sessionStorage.getItem(Encrypt(sessId));
  return !val ? defaultVal : Decrypt(val);
};
export const GetStorage = (sessId, defaultVal = null) => {
  let val =
    typeof window === "undefined"
      ? defaultVal
      : window.localStorage.getItem(Encrypt(sessId));
  return !val ? null : Decrypt(val);
};
export const RemoveSession = (sessId) => {
  if (typeof window !== "undefined") {
    window.sessionStorage.removeItem(Encrypt(sessId));
  }
};
export const RemoveStorage = (sessId) => {
  if (typeof window !== "undefined") {
    window.localStorage.removeItem(Encrypt(sessId));
  }
};
export const GetFirstResult = (pState) => {
  if (!pState) {
    return null;
  }
  if (pState?.length) {
    return pState[0];
  }
  return null;
};
export const GetConfig = (val) => {
  val = val.split(".");
  if (
    val.length === 1
      ? ConfigData[Encrypt(val[0])]
      : val.length === 2
        ? ConfigData[Encrypt(val[0])][Encrypt(val[1])]
        : ConfigData[Encrypt(val[0])][Encrypt(val[1])][Encrypt(val[2])]
  ) {
    return Decrypt(
      val.length === 1
        ? ConfigData[Encrypt(val[0])]
        : val.length === 2
          ? ConfigData[Encrypt(val[0])][Encrypt(val[1])]
          : ConfigData[Encrypt(val[0])][Encrypt(val[1])][Encrypt(val[2])],
    );
  }
  return "";
};
const GetResponseHeader = (responseType = 0) => {
  switch (responseType) {
    case "text":
      return 1;
    case "blob":
      return 2;
    default:
      return 0;
  }
};
export const PostData = (
  action,
  pData,
  storeName,
  executeIndicator = null,
  contentType = "application/json",
  additionalHeaders = {},
  fetchOnlyIfNotExists = false,
) => {
  const { productCode, languageCode } = GetProductAndLanguage(
    window.location.pathname,
  );
  if (fetchOnlyIfNotExists && GetState(storeName)) {
    if (executeIndicator) {
      executeIndicator();
    }
    return;
  }
  const responseType = GetResponseHeader(additionalHeaders?.ResponseType);
  let requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": pData
        ? contentType
          ? contentType
          : "application/json"
        : "text/plain",
      "Access-Control-Allow-Origin": "*",
      Lang: languageCode,
      "x-access-token": User.AccessToken(),
      ...additionalHeaders,
      App: productCode.toLowerCase(),
    },
    body:
      contentType === "multipart/form-data"
        ? pData
        : pData
          ? JSON.stringify(pData)
          : null,
  };
  const postWorker = InitializeCustomWorker(
    (responseAsJson) => {
      if (
        (responseAsJson?.Message ?? "").toLowerCase() ===
        "Failed to authenticate token.".toLowerCase()
      ) {
        UnregisterServiceWorkers(languageCode, productCode, true);
      } else {
        if (storeName) {
          SetState(storeName, responseAsJson?.Results ?? responseAsJson);
        }
        if (executeIndicator) {
          if (typeof executeIndicator === "function") {
            executeIndicator(responseAsJson?.Results ?? responseAsJson);
          } else {
            SetState(executeIndicator, GUID());
          }
        }
      }
    },
    (error) => {
      RemoveState(storeName);
      console.log("Looks like there was a problem:", error);
    },
  );
  const payload = postWorker.payload(action, requestOptions, responseType);
  postWorker.worker.postMessage(payload);
};
